import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "baseline-trip_origin-24px_6a27162b557a3236da31f2a1bdd8279e",
  "use": "baseline-trip_origin-24px_6a27162b557a3236da31f2a1bdd8279e-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"baseline-trip_origin-24px_6a27162b557a3236da31f2a1bdd8279e\"><path fill=\"none\" d=\"M0 0h24v24H0z\" /><path d=\"M2 12C2 6.48 6.48 2 12 2s10 4.48 10 10-4.48 10-10 10S2 17.52 2 12zm10 6c3.31 0 6-2.69 6-6s-2.69-6-6-6-6 2.69-6 6 2.69 6 6 6z\" /><path fill=\"none\" d=\"M0 0h24v24H0z\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id